import styled from "styled-components";

const Row = styled.div`
    padding: 15px 0 15px 0;
    flex: 1;
    display: flex;
    align-items: center;
`;

export default Row;
